import { useCallback, useMemo } from "react"
import { ResearchProjectResult, useListResearch } from "interface/research"
import { SearchDetailResult } from "interface/search"

import { Grid, useGrid } from "components/grid"

import { useResearchGridColumns } from "./columns"
import { ResearchPreviewDialog } from "features/research/dialog/preview"
import { useResearchPreviewDialog } from "features/research/dialog/preview/hooks"

type ResearchPageProps = {
	search: SearchDetailResult
} & ReturnType<typeof useGrid>
export const ResearchPage = ({
	search,
	...others
}: ResearchPageProps) => {
	const {
		projectList: selectedProjectList,
		projectKey: selectedProjectKey,
		setProjectList: setSelectedProjectList,
		openProject: openResearchPreviewDialog,
		close: closeResearchPreviewDialog
	} = useResearchPreviewDialog()

	const { apiRef } = others

	const listState = useListResearch(search.searchId, undefined, { updateTime: search.updateTime })
	const progress = useMemo(
		() => listState.loaded && listState.total ? (listState.loaded / listState.total) * 100 : undefined,
		[listState]
	)
	const projectList = useMemo(
		() => listState.data ?? [],
		[listState]
	)

	const onClickLink = useCallback(
		(projectKey: string | null) => {
			if (!apiRef.current) return
			const api = apiRef.current

			const rowDataList: ResearchProjectResult[] = []
			const rowCount = api.getRowsCount()
			for(let i = 0; i < rowCount; i++) {
				const index = api.getRowIdFromRowIndex(i) as number
				if (index >= 0 && projectList.length > index) {
					rowDataList.push(projectList[index])
				}
			}
			setSelectedProjectList(rowDataList)
			openResearchPreviewDialog(projectKey)
		},
		[setSelectedProjectList, openResearchPreviewDialog, apiRef, projectList]
	)
	const { columnsDef } = useResearchGridColumns({ onClickLink })

	const onDblClick = useCallback(
		(project: ResearchProjectResult) => onClickLink(project.projectKey ?? null),
		[onClickLink]
	)
	return (
		<>
			<Grid
				{...others}
				saveKey="research_grid"
				baseFileName={search.title}
				sheetName="研究"
				loading={listState.loading}
				progress={progress}
				columnsDef={columnsDef}
				dataList={projectList}
				onDblClick={onDblClick}
			/>
			{selectedProjectKey ? (
				<ResearchPreviewDialog
					projectList={selectedProjectList}
					projectKey={selectedProjectKey}
					onClose={closeResearchPreviewDialog}
				/>
			) : <></>}
		</>
	)
}